import type { Dictionnaire } from '../type';

export const auth: Dictionnaire['auth'] = {
  erreurs: {
    identifiants: 'Correo o contraseña incorrectos',
    emailInvalide: 'Dirección de correo no válida',
    compteExiste: 'Ya existe una cuenta con este correo',
    motDePasseFaible: 'Contraseña demasiado débil',
    tropDeTentatives: 'Demasiados intentos, vuelve a intentarlo en unos minutos',
    reseau: 'No se puede conectar, revisa tu red',
    inattendue: 'Algo ha fallado, vuelve a intentarlo en un momento',
    parEmail: 'Inicia sesión con tu dirección de correo',
    age: 'Sirocco está reservado a mayores de 16 años',
    pseudoPris: 'Este nombre de usuario ya está cogido',
    sessionExpiree: 'Tu sesión ha caducado, vuelve a iniciar sesión',
    motDePasseActuel: 'La contraseña actual es incorrecta',
    sansProfil: 'Esta cuenta todavía no tiene perfil de Sirocco. Escríbenos si el problema continúa.',
    connexion: 'No se puede iniciar sesión',
  },
  champs: {
    email: 'Correo electrónico',
    exempleEmail: 'tu@ejemplo.com',
    motDePasse: 'Contraseña',
    retourConnexion: 'Volver al inicio de sesión',
  },
  action: {
    incomplet: 'Este enlace está incompleto.',
    expireNouveau: 'Este enlace ha caducado o ya se ha usado. Pide uno nuevo.',
    expire: 'Este enlace ha caducado o ya se ha usado.',
    sixCaracteres: 'Seis caracteres como mínimo.',
    pasChange: 'No se ha podido cambiar la contraseña. Puede que el enlace haya caducado.',
    titreChange: 'CONTRASEÑA CAMBIADA',
    titreNouveau: 'NUEVA CONTRASEÑA',
    titreRetablie: 'DIRECCIÓN RESTABLECIDA',
    titreConfirmee: 'DIRECCIÓN CONFIRMADA',
    unInstant: 'UN MOMENTO',
    nouveau: 'Nueva contraseña',
    changer: 'Cambiar mi contraseña',
    connecteToi: 'Ya puedes iniciar sesión con tu nueva contraseña.',
    bienvenue: 'Tu cuenta está abierta. Bienvenido.',
    ouvrir: 'Abrir Sirocco',
    continuerSite: 'Continuar en la web',
    pour: { avant: 'Elige una nueva contraseña para', apres: '.' },
  },
  spot: {
    impossible: 'No se puede entrar en este servidor',
    publics: 'Servidores públicos',
    prives: 'Servidores privados',
    bientot: 'Próximamente',
    tuEsMembre: 'Eres miembro de este servidor',
    membre: 'Miembro de este servidor',
    badgePrive: 'Privado',
    reserve: 'Solo para miembros',
    rechercher: 'Busca una ciudad o una región...',
    rechercherLabel: 'Buscar una ciudad o una región',
    accesReserve: 'Acceso solo para miembros',
    rejoindre: 'Entrar en este servidor',
    membres: (n: number) => `${n.toLocaleString('es-ES')} miembro${n === 1 ? '' : 's'}`,
    aucun: (recherche: string) => `Ningún servidor coincide con «${recherche}»`,
    prive: (nom: string) => `${nom} es un servidor privado: solo sus miembros pueden entrar.`,
  },
  confirmer: {
    titre: 'CONFIRMA TU DIRECCIÓN',
    renvoye: 'Correo reenviado.',
    patiente: 'Acaba de salir un correo. Espera un minuto antes de pedir otro y revisa la carpeta de spam.',
    trop: 'Has pedido demasiados correos hoy. Vuelve a intentarlo mañana o revisa la carpeta de spam.',
    echec: 'No se ha podido enviar el correo. Vuelve a intentarlo.',
    renvoyer: 'Reenviar el correo',
    deconnecter: 'Cerrar sesión',
    envoye: {
      avant: 'Hemos enviado un correo de confirmación a',
      apres: '. Pulsa el enlace que contiene para acceder a la aplicación.',
    },
  },
  oubli: {
    impossible: 'No se ha podido enviar',
    titre: 'CONTRASEÑA',
    consigne: 'Escribe tu correo y te enviaremos un enlace para restablecerla.',
    envoyer: 'Enviar el enlace',
    envoye: (email: string) => `Si existe una cuenta para ${email}, te acabamos de enviar un correo.`,
  },
  connexion: {
    impossible: 'No se puede iniciar sesión',
    oublie: '¿Has olvidado tu contraseña?',
    seConnecter: 'Iniciar sesión',
    nouveau: '¿Nuevo en Sirocco?',
    inscrire: 'Regístrate',
  },
  personnaliser: {
    photoImpossible: 'No se ha podido guardar la foto',
    impossible: 'No se ha podido guardar',
    titre: 'Personaliza tu perfil',
    choisirPhoto: 'Elegir mi foto de perfil',
    bio: 'Bio',
    bioExemple: 'Lo que haces aquí, lo que buscas, tu ciudad de antes...',
    continuer: 'Continuar',
  },
  inscription: {
    regles: {
      huit: 'Al menos 8 caracteres',
      casse: 'Mayúsculas y minúsculas',
      chiffre: 'Al menos un número o un carácter especial',
    },
    manque: {
      prenom: 'Escribe tu nombre',
      nom: 'Escribe tu apellido',
      pseudo: 'Elige un nombre de usuario',
      email: 'Escribe tu dirección de correo',
      motDePasse: 'Elige una contraseña',
      naissance: 'Escribe tu fecha de nacimiento',
    },
    naissanceInvalide: 'Fecha de nacimiento no válida',
    conditions: 'Tienes que aceptar las condiciones de uso',
    impossible: 'No se ha podido completar el registro',
    titre: 'REGISTRARSE',
    dejaInscrit: '¿Ya tienes cuenta?',
    seConnecter: 'Iniciar sesión',
    prenom: 'Nombre',
    nom: 'Apellido',
    pseudo: 'Nombre de usuario',
    pseudoExemple: 'Ej.: martin.pecheur',
    naissance: 'Fecha de nacimiento',
    accepteLabel: 'Acepto las condiciones de uso y la política de privacidad de Sirocco',
    accepte: {
      debut: 'Acepto las',
      cgu: 'condiciones de uso',
      et: 'y la',
      confidentialite: 'política de privacidad',
      fin: 'de Sirocco.',
    },
    langues: 'Idiomas que hablas',
    languesAide: 'Las salidas en tus idiomas aparecen primero en la lista. Podrás cambiarlos en tu perfil.',
    jeMInscris: 'Registrarme',
  },
};
